import React from "react";
import { Input } from "../ui/input";
import ErrorText from "./error-text";

import { Label } from "../ui/label";

export default function FormikDate({
  formikProps,
  onChange = () => {},
  name,
  placeholder,
  style,
  className, // other Props
  type,
  size,
  color,
  radius,
  variant,
  shadow,
  removeWrapper = false,
    label,
    min,
}) {
  return (
    <div>
      {label && (
        <Label className="mb-3" htmlFor="inputId">
          {label}
        </Label>
      )}
      <Input
        value={formikProps.values[name]}
        onChange={(e) => {
          formikProps.setFieldValue(name, e.target.value);
          onChange(e.target.value);
        }}
        placeholder={placeholder}
        style={style}
        className={className}
        type={type}
        size={size}
        color={color}
        radius={radius}
        variant={variant}
        shadow={shadow}
        min={min}
        removeWrapper={removeWrapper}
      />
      <ErrorText formikProps={formikProps} name={name} />
    </div>
  );
}
